/** French (Canada) locale for system-settings-ui. */
import type { SystemSettingsLocale } from './en'

export const systemSettingsFrCa = {
  systemSettings: {
    title: `Paramètres du système`,
    tabs: {
      general: `Général`,
      defaults: `Valeurs par défaut`,
      recording: `Enregistrement des appels`,
    },
    common: {
      save: `Enregistrer les modifications`,
      active: `Actif`,
      inactive: `Inactif`,
      yes: `Oui`,
      no: `Non`,
      loading: `Chargement...`,
      selectOption: `-- Sélectionner --`,
      none: `Aucun`,
      unsavedChanges: `Modifications non enregistrées`,
    },
    general: {
      title: `Général`,
      defaultTimeZone: `Fuseau horaire par défaut`,
      callParkTimeout: `Délai d'attente du stationnement d'appels (secondes)`,
      callParkTimeoutHelp:
        'Durée en secondes pendant laquelle un appel reste stationné avant de revenir. Minimum 30 secondes, maximum 1800 secondes. Recommandé : 300.',
      callParkWarning: `Êtes-vous sûr de vouloir laisser les appelants dans le stationnement d'appels pendant {{minutes}} minutes?`,
      extensionsTitle: `Postes`,
      extensionDigits: `Chiffres des postes`,
      enableIntercom: `Activer l'interphone`,
      searchTimezone: 'Rechercher des fuseaux horaires...',
      noTimezonesFound: 'Aucun fuseau horaire trouvé',
    },
    defaults: {
      voiceTitle: `Voix`,
      defaultAreaCode: `Indicatif régional par défaut`,
      areaCodeRange: `L'indicatif régional doit être entre 200 et 998`,
      areaCodeDisallowed: `Cet indicatif régional n'est pas autorisé`,
      defaultCallerId: `Identifiant d'appelant par défaut`,
      faxTitle: `Télécopieur`,
      defaultFaxNumber: `Numéro de télécopieur par défaut`,
      defaultVirtualFax: `Télécopieur virtuel par défaut`,
      defaultVirtualFaxSearchPlaceholder: `Rechercher des extensions de télécopieur virtuel...`,
      defaultVirtualFaxSearchAriaLabel: `Rechercher des extensions de télécopieur virtuel par nom ou numéro`,
      defaultVirtualFaxNoMatches: `Aucune extension de télécopieur virtuel ne correspond à cette recherche.`,
      emergencyTitle: `Valeurs par défaut d'urgence`,
      emergencyName: `Nom d'urgence`,
      emergencyNumber: `Numéro d'urgence`,
      emergencyNumberHelp: `Ce champ est en lecture seule et ne peut pas être modifié ici.`,
      emergencyAlert: `Alerte d'urgence`,
      holdMusicTitle: `Musique d'attente`,
      holdMusicPlaylist: `Musique d'attente`,
      noPlaylists: `Aucune liste de lecture disponible`,
      playlistNotPlayableSuffix: `(aucune piste audio)`,
      playlistEmptyError: `La liste de lecture de musique d'attente sélectionnée ne contient aucune piste audio. Ajoutez des pistes ou choisissez une autre liste de lecture.`,
    },
    recording: {
      title: `Enregistrement des appels`,
      enableInbound: `Activer l'enregistrement des appels entrants`,
      enableOutbound: `Activer l'enregistrement des appels sortants`,
      enableInternal: `Activer l'enregistrement des appels internes`,
    },
    toast: {
      saveSuccess: `Paramètres enregistrés avec succès`,
      saveError: `Échec de l'enregistrement des paramètres`,
      validationError: `Impossible d'enregistrer — veuillez corriger les erreurs ci-dessus`,
    },
    error: {
      loadFailed: `Échec du chargement des paramètres du système. Veuillez réessayer.`,
    },
  },
} satisfies SystemSettingsLocale
